define(function(require, exports, module) {
    'use strict';
    const languageUtil = require('util/language.util');

    module.exports = {
        ...languageUtil,
        /**
         * It is crazy, but in Fab en_GB is interchanged with en.
         * @type {Object}
         */
        imsLocalesMapping: {
            ...languageUtil.imsLocalesMapping,
            en_GB: 'en'
        }
    };
});
